const BASE_URL = 'https://json-server-news-site.onrender.com'

export const API_URL = (slug) => `${BASE_URL}/${slug}`